export default __webpack_public_path__ + "static/media/team-3.b75146da.jpg";